// extracted by mini-css-extract-plugin
module.exports = {"FootnoteCount":"FootnoteCount_FootnoteCount__e0zNt","IconContainer":"FootnoteCount_IconContainer__NPXAL","Label":"FootnoteCount_Label__Mwahq"};